import type {
  AttendanceParams,
  DealsPipelinesParams,
  ExpenseParams,
  FollowUpsParams,
  GetFeedActivityParams,
  GetTopAbsenteesParams,
  GetTopEmployeeLocationParams,
  GetTopMeetingsParams,
  GetTopTaskViewParam,
  LeadsAllConversionParams,
  LeadsConversionParams,
  LeadTransactionParams,
  LocationUsersParams,
  LostReasonParam,
  LostReasonListParam,
  OpportunityAllConversionParams,
  OpportunityConversionParams,
  TagsOpportunityParams,
  LeadOpportunityParams,
} from "@/types/dashboardtypes";
import { privateRequest, type ApiResponse } from "../axios";
import { saveAsExcelFile } from "../excelService/excelSevice";

const ENDPOINTS = {
  DASHBOARD360_TOP_ABSENTEES: "api/TopAbsent",
  DASHBOARD360_TOP_HALF_DAYS: "api/TopHalfDays",
  DASHBOARD360_TOP_EXTRA_DAYS: "api/TopExtraDays",
  DASHBOARD360_TOP_PLANNED_LEAVES: "api/TopUpcomingLeaves",
  DASHBOARD360_TOP_CLAIMS: "api/TopClaims",
  DASHBOARD360_EMPLOYEECOUNT_LOCATION: "api/EmployeeCountByLocation",
  DASHBOARD360_EXPENSE: "api/TopRecentExpense",
  DASHBOARD360_ADDED_CUSTOMER: "api/CustomerAddedVisitDeal",
  DASHBOARD360_TOP_CUSTOMER_ORDER: "api/TopCustomersOrders",
  DASHBOARD360_DEALS_AND_PIPELINES: "api/DealStagePipeline",
  DASHBOARD360_LEADS_CONVERSION: "api/LeadCount",
  DASHBOARD360_OPPORTUNITY_CONVERSION: "api/OpportunityCount",
  DASHBOARD360_LOST_REASON: "api/OpportunityReasonCount",
  DASHBOARD360_LOST_REASON_LIST: "api/OpportunityReasonList",
  DASHBOARD360_TAGS: "api/GetTagsAgainstOpportunity",
  DASHBOARD360_TAGS_WON: "api/GetTagsAgainstWonOpportunity",
  DASHBOARD360_TAGS_LOSS: "api/GetTagsAgainstLostOpportunity",
  DASHBOARD360_ALL_OPP_BY_TAG: "api/GetAllOpportunitiesbyTag",
  DASHBOARD360_WON_OPP_BY_TAG: "api/GetAllWonOpportunitiesbyTag",
  DASHBOARD360_LOST_OPP_BY_TAG: "api/GetAllLostOpportunitiesbyTag",
  DASHBOARD360_OPPORTUNITY_LEAD: "api/OpportunityByLeadSource",
  DASHBOARD360_ALL_OPPORTUNITY_LEAD: "api/GetAllOpportunityByLeadSource",
  DASHBOARD360_LEAD_ACCOUNT: "api/LeadsOnAccountStage",
  DASHBOARD360_ALL_LEADS_ON_ACCOUNT_STAGE_BY_LEAD_SOURCE:
    "api/GetAllLeadsOnAccountStageByLeadSource",
  DASHBOARD360_ALL_WON_OPPORTUNITIES: "api/GetAllWonOpportunities",
  DASHBOARD360_EXPENSE_BY_WEEK: "api/ExpenseByWeek",
  DASHBOARD360_INDIVIDUAL_TASK: "api/GetAllIndiviualTask",
  DASHBOARD360_TEAM_TASK: "api/GetAllTeamWiseTask",
  DASHBOARD360_SALES_PERFORMACE: "api/SalePerformance",
  DASHBOARD360_LEAD_SOURCE: "api/CustomerBySource",
  DASHBOARD360_LEAD_STATUS: "api/CustomerByStatus",
  DASHBOARD360_LEAD_STAGE: "api/CustomerByStage",
  DASHBOARD360_PRODUCT_STATUS: "api/GetProductOrderStatus",
  DASHBOARD360_FOLLOW_UPS: "api/DealPipeline/FolloWups",
  DASHBOARD360_TOP_CALL_BY: "api/TopCallBy",
  DASHBOARD360_TOP_CALL_TO: "api/TopCallTo",
  DASHBOARD360_BOTTOM_CALL_BY: "api/BottomCallBy",
  DASHBOARD360_BOTTOM_CALL_TO: "api/BottomCallTo",
  DASHBOARD360_TOP_PRODUCT: "api/TopProduct",
  DASHBOARD360_TOP_MEETINGS: "api/TopMeeting",
  DASHBOARD360_TASK_VIEW: "api/GetAllListViewTask",
  DASHBOARD360_FEED_ACTIVITY: "api/FeedActivityLrm",
  DASHBOARD360_ALL_ATTENDANCE: "api/GetAllAttendanceReport",
  DASHBOARD360_ALL_LOCATION_USER: "api/GetAllLocationByUsers",
  DASHBOARD360_ALL_EXPESE: "api/GetAllExpense",
  DASHBOARD360_CUSTOMER_VIEW: "api/GetAllCustomerViewReport",
  DASHBOARD360_ALL_CALL: "api/GetAllCall",
  DASHBOARD360_ALL_DEALSPIPELINES: "api/GetAllDealPipeline",
  DASHBOARD360_LEAD_CONVERSION_ALL_CUSTOMER: "api/LeadConversionAllCustomer",
  DASHBOARD360_CONVERTED_LEADS: "api/ConvertedLeads",
  DASHBOARD360_CONVERSION_OPPORTUNITY: "api/ConvertedOpportunity",
  DASHBOARD360_ALL_OPPORTUNITY: "api/AllOpportunity",
  DASHBOARD360_LEAD_TRANSACTION: "api/CRM/v1/LeadTransaction",
  DASHBOARD360_LEAD_STATUS_VALUES: "/api/CRM/LeadStatus",
  DASHBOARD360_VISIT_PURPOSES: "/api/CRM/VisitPurposes",
  DASHBOARD360_VISIT_METRICS: "/api/LeadsInsight/VisitsMetrics",
  DASHBOARD360_OPPORTUNITY_METRICS: "/api/LeadsInsight/OpportunityMetrics",
  DASHBOARD360_ORDER_METRICS: "/api/LeadsInsight/OrderMetrics",
  DASHBOARD360_MOST_ORDERED_PRODUCT: "/api/LeadsInsight/MostOrderProducts",
  DASHBOARD360_TASK_METRICS: "/api/LeadsInsight/VisitFormsAndTaskMetrics",
  DASHBOARD360_REFERRAL_BUSSINESS: "/api/LeadsInsight/ReferralBusiness/",
  DASHBOARD360_SALE360_VIEW: "api/GetSale360View",
  DASHBOARD360_TEAM_TASK360_VIEW: "api/GetTeamTask360View",
  DASHBOARD360_INDIVIDUAL_TASK_VIEW: "api/Task/Indiviual/View",
  DASHBOARD360_LEADS_COUNT: "api/LeadOpportunityCount",
  DASHBOARD360_LEADS_COUNT_EXPORT :"API/LeadOpportunityCount/Export",
};



const exportLeadOpportunityCount = async (data: any) => {
  const query = new URLSearchParams({
    "opportunity.from": data.from ?? "",
    "opportunity.to": data.to ?? "",
    "opportunity.fromDate": data.fromDate ?? "",
    "opportunity.toDate": data.toDate ?? "",
    "opportunity.sortBy": data.sortBy ?? "",
    "opportunity.search": data.search ?? "",
  }).toString();

  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.DASHBOARD360_LEADS_COUNT_EXPORT}?${query}`,
    {
      responseType: "arraybuffer",
    },
  );

  saveAsExcelFile(res, "LeadOpportunityCount");
};

// Generic GET request
const getRequest = async <T>(url: string, params?: any): Promise<T> => {
  const response = await privateRequest.get(url, { params });
  return response.data;
};

// Generic POST request
const postRequest = async <T>(url: string, body?: any): Promise<T> => {
  const response = await privateRequest.post(url, body);
  return response.data;
};

// -------------------------
// Dashboard360 API Methods
// -------------------------
const Dashboard360Service = {
  getTopAbsentees: (params: GetTopAbsenteesParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_TOP_ABSENTEES, params),
  getTopHalfDays: (params: GetTopAbsenteesParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_TOP_HALF_DAYS, params),
  getTopExtraDays: (params: GetTopAbsenteesParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_TOP_EXTRA_DAYS, params),
  getTopPlannedLeaves: (params: GetTopAbsenteesParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_TOP_PLANNED_LEAVES, params),
  getTopClaims: (params: GetTopAbsenteesParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_TOP_CLAIMS, params),

  getEmployeeCountByLocation: (params: GetTopEmployeeLocationParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_EMPLOYEECOUNT_LOCATION, params),
  getTopExpense: (params: GetTopEmployeeLocationParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_EXPENSE, params),
  getAddedCustomer: (params: GetTopEmployeeLocationParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_ADDED_CUSTOMER, params),
  getTopCustomerByOrder: (params: GetTopAbsenteesParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_TOP_CUSTOMER_ORDER, params),
  getDealsAndPipelines: (params: DealsPipelinesParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_DEALS_AND_PIPELINES, params),
  getLeadsConversion: (params: LeadsConversionParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_LEADS_CONVERSION, params),
  getOpportunityConversion: (params: OpportunityConversionParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_OPPORTUNITY_CONVERSION, params),

  getLostReason: (params: LostReasonParam) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_LOST_REASON, params),
    getLostReasonLists: (params: LostReasonListParam) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_LOST_REASON_LIST, params),
  getTagsOpportunity: (params: TagsOpportunityParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_TAGS, params),
  getTagsWonOpportunity: (params: TagsOpportunityParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_TAGS_WON, params),
  getTagsLossOpportunity: (params: TagsOpportunityParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_TAGS_LOSS, params),
  getAllOpportunitiesByTag: (params: any) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_ALL_OPP_BY_TAG, params),
  getAllWonOpportunitiesByTag: (params: any) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_WON_OPP_BY_TAG, params),
  getAllLostOpportunitiesByTag: (params: any) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_LOST_OPP_BY_TAG, params),
  getOpportunityByLead: (params: TagsOpportunityParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_OPPORTUNITY_LEAD, params),
  getAllOpportunityByLeadSource: (params: any) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_ALL_OPPORTUNITY_LEAD, params),
  getLeadAccount: (params: TagsOpportunityParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_LEAD_ACCOUNT, params),
  getAllLeadsOnAccountStageByLeadSource: (params: any) =>
    getRequest<any[]>(
      ENDPOINTS.DASHBOARD360_ALL_LEADS_ON_ACCOUNT_STAGE_BY_LEAD_SOURCE,
      params,
    ),
  getAllWonOpportunities: (params: any) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_ALL_WON_OPPORTUNITIES, params),
  getExpenseByWeek: (params: GetTopAbsenteesParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_EXPENSE_BY_WEEK, params),

  getAllIndividualTask: (params: GetTopEmployeeLocationParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_INDIVIDUAL_TASK, params),
  getAllTeamWiseTask: (params: GetTopEmployeeLocationParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_TEAM_TASK, params),
  getSalePerformance: (params: GetTopAbsenteesParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_SALES_PERFORMACE, params),
  getSale360View: (params: any) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_SALE360_VIEW, params),
  getTeamTask360View: (params: any) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_TEAM_TASK360_VIEW, params),
  getIndividualTaskView: (params: any) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_INDIVIDUAL_TASK_VIEW, params),

  getCustomerBySource: (params: GetTopAbsenteesParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_LEAD_SOURCE, params),
  getCustomerByStatus: (params: GetTopAbsenteesParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_LEAD_STATUS, params),
  getCustomerByStage: (params: GetTopAbsenteesParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_LEAD_STAGE, params),
  getProductOrderStatus: (params: TagsOpportunityParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_PRODUCT_STATUS, params),
  getFollowUps: (params: FollowUpsParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_FOLLOW_UPS, params),

  getTopFiveCallBy: (params: GetTopEmployeeLocationParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_TOP_CALL_BY, params),
  getTopFiveCallTo: (params: GetTopEmployeeLocationParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_TOP_CALL_TO, params),
  getBottomFiveCallBy: (params: GetTopEmployeeLocationParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_BOTTOM_CALL_BY, params),
  getBottomFiveCallTo: (params: GetTopEmployeeLocationParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_BOTTOM_CALL_TO, params),

  getTopProduct: (params: GetTopAbsenteesParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_TOP_PRODUCT, params),
  getTopMeetings: (params: GetTopMeetingsParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_TOP_MEETINGS, params),
  getAllListViewTask: (params: GetTopTaskViewParam) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_TASK_VIEW, params),
  getFeedActivityLrm: (params: GetFeedActivityParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_FEED_ACTIVITY, params),

  getAllAttendanceData: (params: AttendanceParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_ALL_ATTENDANCE, params),
  getAllLocationUsers: (params: LocationUsersParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_ALL_LOCATION_USER, params),
  getAllExpense: (params: ExpenseParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_ALL_EXPESE, params),
  getAllCustomerViewReport: (params: AttendanceParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_CUSTOMER_VIEW, params),
  getAllCall: (params: AttendanceParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_ALL_CALL, params),
  getAllDealPipeline: (params: DealsPipelinesParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_ALL_DEALSPIPELINES, params),
  getLeadConversionAllCustomer: (params: LeadsAllConversionParams) =>
    getRequest<any[]>(
      ENDPOINTS.DASHBOARD360_LEAD_CONVERSION_ALL_CUSTOMER,
      params,
    ),
  getConvertedLeads: (params: LeadsAllConversionParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_CONVERTED_LEADS, params),
  getConvertedOpportunity: (params: OpportunityAllConversionParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_CONVERSION_OPPORTUNITY, params),
  getAllOpportunity: (params: OpportunityAllConversionParams) =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_ALL_OPPORTUNITY, params),
  getLeadTransaction: (body: LeadTransactionParams) =>
    postRequest<any[]>(ENDPOINTS.DASHBOARD360_LEAD_TRANSACTION, body),
  getLeadStatus: () =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_LEAD_STATUS_VALUES),
  getVisitPurposes: () =>
    getRequest<any[]>(ENDPOINTS.DASHBOARD360_VISIT_PURPOSES),
  getVisitsMetrics: (id: any, params: any) =>
    getRequest<any[]>(`${ENDPOINTS.DASHBOARD360_VISIT_METRICS}/${id}`, params),
  getOpportunityMetrics: (id: any, params: any) =>
    getRequest<any[]>(
      `${ENDPOINTS.DASHBOARD360_OPPORTUNITY_METRICS}/${id}`,
      params
    ),
  getOrderMetrics: (id: any, params: any) =>
    getRequest<any[]>(`${ENDPOINTS.DASHBOARD360_ORDER_METRICS}/${id}`, params),
  getMostOrderedProducts: (id: any, params: any) =>
    getRequest<any[]>(
      `${ENDPOINTS.DASHBOARD360_MOST_ORDERED_PRODUCT}/${id}`,
      params
    ),
  getTaskMetrics: (id: any, params: any) =>
    getRequest<any[]>(`${ENDPOINTS.DASHBOARD360_TASK_METRICS}/${id}`, params),
  getReferralBussiness: (id: any, params: any) =>
    getRequest<any[]>(
      `${ENDPOINTS.DASHBOARD360_REFERRAL_BUSSINESS}/${id}`,
      params
    ),
  getCustomFields: (id: any, params: any) =>
    getRequest<any[]>(
      `${ENDPOINTS.DASHBOARD360_REFERRAL_BUSSINESS}/${id}`,
      params
    ),

  getLeadOpportunityCount: (params: LeadOpportunityParams) =>
  getRequest<any[]>(ENDPOINTS.DASHBOARD360_LEADS_COUNT, params),
  
  getLeadOpportunityReport: (params: LeadOpportunityParams) =>
  getRequest<any[]>(ENDPOINTS.DASHBOARD360_LEADS_COUNT, params),
  exportLeadOpportunityCount
};

export default Dashboard360Service;
